const audits = {
  auditdanger: 'Security Issues',
  auditwarning: 'Possible Issues',
  auditsuccess: 'Everything good',
  viewdetails: 'View Details',
  title: 'Security Report:',
  summary: 'Summary',
  backtooverview: 'Back to Overview',
  joomlaconfig: {
    title: 'Joomla! Configuration',
    description: 'Checks for various security-relevant settings in the Joomla configuration screens.',
    passed_audits: 'Passed audits',
    audits_passed: 'audits passed',
    opportunity: 'Opportunity',
    more_information: 'More Information',
    opportunities: 'Opportunities',
    opportunities_desc: 'Things you should do to improve the security level',
    allpassed: 'All audits have passed, great job!',
    debug_on: {
      title: 'Debug mode enabled',
      description: 'Debug mode should never be activated for publicly accessible websites. If debug mode is enabled, confidential page information is publicly accessible, which has a massive impact on the security of the page.'
    },
    ftp_on: {
      title: 'FTP mode enabled',
      description: 'If the sites FTP mode is enabled, there is a possibility that attackers could exploit your FTP credentials.'
    },
    excessive_session: {
      title: 'Excessive Session length',
      description: 'Sites should not have an excessive session length. You should limit the session length to a maximum of 60 minutes.'
    },
    captcha_off: {
      title: 'No captcha configured',
      description: 'A captcha plugin should be enabled on the page to prevent attackers from targeting forms on the page with spam messages.'
    },
    mailtofriend_on: {
      title: 'Mail-to-friend feature enable',
      description: 'The Mail-to-friend feature of com_content should be disabled as it\'s frequently used for spamming.'
    },
    privileged_defaultgroup: {
      title: 'Privileged default user group',
      description: 'A privileged (non-"Registered") user group is configured as the default user group for new users.'
    }
  },
  suspiciousfiles: {
    title: 'Suspicious Files',
    description: 'Filesystem scan for potentially malicious code patterns.',
    togglefiles: 'Toggle ignored Files',
    ignorefile: 'Ignore file for this and future audits',
    viewcode: 'View Code',
    finding: 'Finding',
    inline: 'in line',
    allpassed: 'No suspicious files on your site, your site is clean!'
  },
  modifiedfiles: {
    title: 'Modified CMS Core Files',
    description: 'List of modified CMS core files which might be hacked.',
    viewcode: 'View Code',
    allpassed: 'No modified core files, your site is clean!'
  },
  users: {
    title: 'User Database',
    description: 'Checks for various abnormalities in the user database that are relevant for the security of your site',
    passed_audits: 'Passed audits',
    audits_passed: 'audits passed',
    opportunity: 'Opportunity',
    more_information: 'More Information',
    opportunities: 'Opportunities',
    opportunities_desc: 'Things you should do to improve the security level',
    allpassed: 'All audits have passed, great job!',
    affectedusers: 'Affected users:',
    abandoned_accounts: {
      title: 'Unused privileged accounts',
      description: 'Inactive privileged accounts should be deleted. An account is considered "inactive" either if it never logged in at all or hasn\'t been used in the last 6 months'
    },
    weak_passwords: {
      title: 'MD5 Passwords',
      description: 'Passwords hashed with md5 are extremly easy to crack. Set a new password to make sure that an up-to-date password hashing algorithm is used.'
    },
    admin_name_user: {
      title: 'Account with "admin" username',
      description: '"Admin" should no be used as a username as it\' easily predictable.'
    }
  }
}

export default audits
